import { productMapper, widgetSettingsMapper, productArrayMapper } from '../mappers/cdn.js';
import { cdnRequest } from '../utils/request.js';
const BASE_CDN_VERSION = "2020-12";
const DEFAULT_STORE_SETTINGS = {
  store_currency: {
    currency_code: "USD",
    currency_symbol: "$",
    decimal_separator: ".",
    thousands_separator: ",",
    currency_symbol_location: "left"
  }
};
const promiseCache = /* @__PURE__ */new Map();
function cacheRequest(cacheKey, request) {
  if (!promiseCache.has(cacheKey)) {
    promiseCache.set(cacheKey, request());
  }
  return promiseCache.get(cacheKey);
}
async function getCDNProduct(externalProductId, query) {
  const version = query?.version ?? "2020-12";
  const {
    product
  } = await cacheRequest(`product.${externalProductId}.${version}`, () => cdnRequest("get", `/product/${version}/${externalProductId}.json`));
  if (version === "2020-12") {
    return productMapper(product);
  }
  return product;
}
async function getCDNStoreSettings() {
  const storeSettings = await cacheRequest("storeSettings", () => cdnRequest("get", `/${BASE_CDN_VERSION}/store_settings.json`).catch(() => {
    return DEFAULT_STORE_SETTINGS;
  }));
  return storeSettings;
}
async function getCDNWidgetSettings() {
  const {
    widget_settings
  } = await cacheRequest("widgetSettings", () => cdnRequest("get", `/${BASE_CDN_VERSION}/widget_settings.json`));
  const widgetSettings = widgetSettingsMapper(widget_settings);
  return widgetSettings;
}
async function getCDNProductsAndSettings() {
  const {
    products,
    widget_settings,
    store_settings,
    meta
  } = await cacheRequest("productsAndSettings", () => cdnRequest("get", `/product/${BASE_CDN_VERSION}/products.json`));
  if (meta?.status === "error") {
    return Promise.reject(meta.message);
  }
  return {
    products: productArrayMapper(products),
    widget_settings: widgetSettingsMapper(widget_settings),
    store_settings: store_settings ?? {}
  };
}
async function getCDNProducts() {
  const {
    products
  } = await getCDNProductsAndSettings();
  return products;
}
async function getCDNProductAndSettings(externalProductId) {
  const [product, store_settings, widget_settings] = await Promise.all([getCDNProduct(externalProductId), getCDNStoreSettings(), getCDNWidgetSettings()]);
  return {
    product,
    store_settings,
    widget_settings,
    storeSettings: store_settings,
    widgetSettings: widget_settings
  };
}
async function getCDNBundleSettings(externalProductId) {
  const {
    bundle_product
  } = await getCDNProduct(externalProductId);
  return bundle_product;
}
async function resetCDNCache() {
  return Array.from(promiseCache.keys()).forEach(key => promiseCache.delete(key));
}
export { getCDNBundleSettings, getCDNProduct, getCDNProductAndSettings, getCDNProducts, getCDNProductsAndSettings, getCDNStoreSettings, getCDNWidgetSettings, resetCDNCache };